import { render, staticRenderFns } from "./GradeDeColetaEntrega.vue?vue&type=template&id=7b54b131"
import script from "./GradeDeColetaEntrega.vue?vue&type=script&lang=js"
export * from "./GradeDeColetaEntrega.vue?vue&type=script&lang=js"
import style0 from "./GradeDeColetaEntrega.vue?vue&type=style&index=0&id=7b54b131&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports